import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Megaphone } from 'lucide-react'
import styles from './CampaignsHookTicker.module.css'

// Small, easy-to-miss-on-purpose nudge toward Campaigns, sitting in the
// otherwise-empty space left of the date filter on the Overview dashboard.
// Indian salon owners are the audience — price-conscious, tech-reluctant,
// unmoved by "AI-powered marketing platform" language — so every line here
// is a short, concrete, loss-aversion or comparison hook, not a feature
// pitch. One line at a time, rotating slowly, styled to blend into the
// toolbar rather than compete with it.
const HOOK_LINES = [
    "Pamphlets don't work anymore. WhatsApp does.",
    "Bring your customers back before the season starts.",
    "Don't lose 30% of your repeat business to silence.",
    "One WhatsApp message can bring back one more booking.",
    "Your customers forgot you exist — remind them today.",
    "No design skills needed. Just tap send.",
    "Empty chairs on a slow day? Fill them with one message.",
    "Other salons nearby are already messaging their customers.",
    "Takes 2 minutes. Costs less than a cup of chai.",
    "Turn your old customer list into repeat bookings.",
]

const ROTATE_MS = 3600

const CampaignsHookTicker = () => {
    const nav = useNavigate()
    const [index, setIndex] = useState(0)

    useEffect(() => {
        const t = setInterval(() => setIndex(i => (i + 1) % HOOK_LINES.length), ROTATE_MS)
        return () => clearInterval(t)
    }, [])

    return (
        <button
            className={styles.ticker}
            onClick={() => nav('/communications')}
            type="button"
            title="Explore Campaigns"
        >
            <Megaphone size={11} className={styles.tickerIcon} />
            <span className={styles.tickerTrack}>
                <span key={index} className={styles.tickerLine}>{HOOK_LINES[index]}</span>
            </span>
        </button>
    )
}

export default CampaignsHookTicker
